export const gatewayDocumentTypes = '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png';
export const gatewayDocumentKey = document => document.temp_key || document.object_key || document.file_path;

export const queueGatewayDocuments = (documents, files) => {
  if (documents.length + files.length > 20) throw new Error('Each payment gateway supports up to 20 documents.');
  for (const file of files) {
    const extension = `.${file.name.split('.').pop().toLowerCase()}`;
    if (!gatewayDocumentTypes.split(',').includes(extension)) throw new Error('Only PDF, Word, Excel, JPG, and PNG files are allowed.');
    if (file.size > 10 * 1024 * 1024) throw new Error('Each document must be 10MB or smaller.');
  }
  return [...documents, ...files.map(file => ({ temp_key: crypto.randomUUID(), file, label: '',
    original_name: file.name, size: file.size, uploaded_at: null }))];
};

const serializeDocuments = (documents, files) => documents.map(document => {
  if (document.file) {
    const upload_index = files.length;
    files.push(document.file);
    return { upload_index, label: document.label || '' };
  }
  return { file_path: document.file_path, object_key: document.object_key, label: document.label || '' };
});

const buildDocumentRequest = (payload, files) => {
  if (!files.length) return payload;
  if (files.length > 20) throw new Error('Upload up to 20 new documents per save.');
  const request = new FormData();
  request.append('payload', JSON.stringify(payload));
  files.forEach(file => request.append('documents', file));
  return request;
};

export const buildGatewayDocumentRequest = data => {
  if (data.documents === undefined) return data;
  const files = [];
  return buildDocumentRequest({ ...data, documents: serializeDocuments(data.documents, files) }, files);
};

export const buildMerchantDocumentRequest = data => {
  const files = [];
  const payload = { ...data, ...(data.payment_gateways ? {
    payment_gateways: data.payment_gateways.map(gateway => ({ ...gateway, ...(gateway.documents === undefined ? {} : {
      documents: serializeDocuments(gateway.documents, files)
    }) }))
  } : {}) };
  return buildDocumentRequest(payload, files);
};
